import { defineMessages } from 'react-intl';

const messages = defineMessages({
  emptyList: {
    id: 'commande.cardList.emptyList',
    defaultMessage: 'Aucune commande disponible.',
  },
  emptySearch: {
    id: 'commande.cardList.emptySearch',
    defaultMessage: 'Aucune commande ne correspond à votre recherche.',
  },
});

export default messages;
